module.exports = __webpack_public_path__ + "static/media/homeImageMobile.701d9418.png";